export default __webpack_public_path__ + "static/media/web-branch_banner.b1d32339.jpg";